import { useState } from "react";
import { motion, AnimatePresence, LayoutGroup } from "framer-motion";
import { products } from "@/data/products";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";

const tabs = ["all", "services", "hardware"];

export const Catalog = () => {
  const { t } = useLang();
  const [tab, setTab] = useState("all");
  const list = products.filter((p) => tab === "all" || (tab === "services" ? p.type === "service" : p.type === "hardware"));

  return (
    <section id="catalog" className="relative py-20 sm:py-28" data-testid="catalog-section">
      <div className="glow-orb w-[600px] h-[600px] bg-[#00f2fe]/[0.05] -top-40 -left-60" />
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <Reveal>
            <div className="eyebrow mb-6">{t.products.eyebrow}</div>
            <h2 className="font-display font-extrabold tracking-[-0.02em] text-2xl sm:text-3xl lg:text-4xl text-[#f4f2ec] leading-[1.1]" data-testid="catalog-title">
              {t.products.title}
            </h2>
            <p className="mt-6 max-w-lg text-[#8a8a8a] text-sm">{t.products.sub}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <LayoutGroup>
              <div className="seg" role="tablist" data-testid="catalog-tabs">
                {tabs.map((k) => (
                  <button key={k} data-active={tab === k} onClick={() => setTab(k)} role="tab" data-testid={`catalog-tab-${k}`}>
                    {tab === k && (
                      <motion.span
                        layoutId="seg-pill"
                        className="absolute inset-0 -z-10 rounded-full"
                        style={{ background: "linear-gradient(135deg,#7df9ff,#00f2fe)", boxShadow: "0 0 18px rgba(0,242,254,0.4)" }}
                        transition={{ type: "spring", stiffness: 400, damping: 34 }}
                      />
                    )}
                    {t.products[k]}
                  </button>
                ))}
              </div>
            </LayoutGroup>
          </Reveal>
        </div>

        <motion.div layout className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="product-grid">
          <AnimatePresence mode="popLayout">
            {list.map((p, i) => (
              <motion.div
                key={p.id}
                layout
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.06 }}
              >
                <ProductCard product={p} />
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};
